const getRawBackendMessage = (data) => {
    if (typeof data === 'string') return data;
    if (!data || typeof data !== 'object') return '';
    return data?.mensagem || data?.message || data?.erro || data?.error?.message || '';
};

export const getBackendErrorMessage = (error, fallbackMessage = '') => {
    const status = error?.response?.status;
    const message = getRawBackendMessage(error?.response?.data);

    if (status === 403) {
        return 'Você não tem permissão para realizar esta ação. Se necessário, solicite acesso ao administrador.';
    }

    return message || fallbackMessage;
};
